import { useEffect, useState } from "react";

import { api } from "../../../services/Api";

export default function useFaturamentoSoftlab({
  dataInicio,
  dataFim,
  competencia,
  gatilhoAtualizacao,
  enqueueSnackbar,
}) {
  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let consultaAtiva = true;

    (async () => {
      try {
        setLoading(true);
        const { data: results } = await api.get(
          "/api/BuscaPorPedidos/geradoSoftlab",
          {
            params: {
              data_inicial: dataInicio,
              data_final: dataFim,
              competencia,
            },
          },
        );

        if (consultaAtiva) {
          setDados(results);
        }
      } catch (error) {
        if (consultaAtiva) {
          enqueueSnackbar("Erro ao buscar faturamento do Softlab.", {
            variant: "error",
          });
        }
      } finally {
        if (consultaAtiva) {
          setLoading(false);
        }
      }
    })();

    return () => {
      consultaAtiva = false;
    };
    // O comportamento legado atualiza o Softlab no carregamento inicial e ao
    // acionar Pesquisar; alterações isoladas dos campos atualizam apenas lotes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enqueueSnackbar, gatilhoAtualizacao]);

  return { dados, loading };
}
